<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Serviços</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="two wide field">
                  <label for="service-search-cod">Código</label>
                  <input
                    type="text"
                    name="service-search-cod"
                    v-model="searchForm.cod"
                  />
                </div>
                <div class="six wide field">
                  <label for="service-search-description">Descrição</label>
                  <input
                    type="text"
                    name="service-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              :columns="gridColumns"
              resource="services"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from '@/components/grid';
import SearchMixins from '@/mixins/search_mixins';

export default {
  name: 'services',
  mixins: [SearchMixins],
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      searchForm: {
        description: null,
        cod: null
      },
      query: {},
      gridColumns: [
        { description: null, kind: 'status', field: 'enable' },
        { description: null, kind: 'edit', field: 'id' },
        { description: 'Cod', field: 'id' },
        { description: 'Serviço', field: 'description' }
      ]
    };
  },

  mounted() {
    this._initSearchForm();
    this.search(this.$route.query.page);
  },

  methods: {
    search(page = 1) {
      this._addSearchToQueryParams();

      const query = {
        q: {
          description_cont: this.searchForm.description,
          id_eq: this.searchForm.cod
        },
        page: page
      };

      this.$refs.grid.toggleLoading();
      Api.services
        .search(query)
        .then(async response => {
          this.$refs.grid.setItems(response.data.services);
          this.$refs.grid.setPaginate(response.data.pagination);
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
